import * as Actions from '../Actions/EmpresaPessoaProdutoActions';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
};


const EmpresaPessoaProdutoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAPESSOAPRODUTO:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAPRODUTO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAPRODUTO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAPRODUTO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaPessoaProdutoReducer
export default reducer;
